export const hifi = {
  madridhifi_invoice_not_associated_deliverynote: `The invoice is not associated with delivery note.`,
  madridhifi_item_not_associated_deliverynoteitems: `Invoice item #{{0}} is not associated with any delivery note items.`,
  madridhifi_item_amount_missmatch: `Item #{{0}} amount {{1}} does not match the delivery note item amount (Price × Quantity) {{2}}.`,
  madridhifi_invoice_amount_unmatch_deliverynote_amount: `Invoice total amount '{{0}}' does not match with delivery note total amount '{{1}}'`,
};
